<div id="record-history-dialog" class="kl-record-history">
  @if (persistUser(); as pu) {
    <div class="kl-record-history__persist">
      <div class="kl-record-history__persist-col">
        <div class="kl-record-history__row">
          <span class="kl-record-history__label">{{ 'added' | translate }}</span>
          <span class="kl-record-history__value">{{ $any(pu['created_user'])?.full_name }}</span>
        </div>
        <div class="kl-record-history__row">
          <span class="kl-record-history__label">{{ 'added_date' | translate }}</span>
          <span class="kl-record-history__value">{{ fmtDt(pu['created_date']) }}</span>
        </div>
      </div>
      <div class="kl-record-history__persist-col">
        <div class="kl-record-history__row">
          <span class="kl-record-history__label">{{ 'last_changed' | translate }}</span>
          <span class="kl-record-history__value">{{ $any(pu['modified_user'])?.full_name }}</span>
        </div>
        <div class="kl-record-history__row">
          <span class="kl-record-history__label">{{ 'last_modified_date' | translate }}</span>
          <span class="kl-record-history__value">{{ fmtDt(pu['modified_date']) }}</span>
        </div>
      </div>
    </div>
  }
  @if (tabs().length) {
    <p-tabs class="kl-record-history__tabs" [value]="tabs()[0].tab_name">
      <p-tablist>
        @for (tab of tabs(); track tab.tab_name) {
          <p-tab [value]="tab.tab_name">{{ tab.tab_header | translate }}</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        @for (tab of tabs(); track tab.tab_name) {
          <p-tabpanel [value]="tab.tab_name">
            <div class="kl-record-history__panels">
              @for (history of historiesFor(tab.tab_name); track $index) {
                @for (property of $any(history).properties ?? []; track $index) {
                  <div class="kl-record-history__block" [class.kl-record-history__block--alt]="$even">
                    <div class="kl-record-history__meta">
                      <span class="kl-record-history__meta-label">{{ 'changed_person' | translate }}</span>
                      <span class="kl-record-history__meta-user">{{ $any(history).user }}</span>
                      <span class="kl-record-history__meta-sep">·</span>
                      <time [attr.datetime]="$any(history).date ?? ''">{{ fmtDt($any(history).date) }}</time>
                    </div>
                    <div class="kl-record-history__table-wrap">
                      <table class="kl-record-history__table">
                        <thead>
                          <tr>
                            <th>{{ 'status' | translate }}</th>
                            <th>{{ 'field' | translate }}</th>
                            <th>{{ 'original_value' | translate }}</th>
                            <th>{{ 'new_value' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ transLabel($any(history).trans_type) }}</td>
                            <td>{{ $any(property).field | translate }}</td>
                            <td>{{ $any(property).old_value | translate }}</td>
                            <td>{{ $any(property).new_value | translate }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                }
              }
            </div>
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  }
</div>
